import useModals from 'src/Hooks/useModals'
import { EmsIdlePeriodLegacyFormField, IdlePeriodStatusProcessingType } from 'src/Libs/smart-charge/types'
import { useField, useFormikContext } from 'formik'
import { PeriodFormInputType } from 'src/Libs/types'

interface UseIdlePeriodHook {
  toggleForSinglePeriodDialog: (processingType: IdlePeriodStatusProcessingType) => void
}

const useIdlePeriod = (formFieldName: string): UseIdlePeriodHook => {
  const { openSmartChargeToggleIdlePeriodDialog } = useModals()
  const { setFieldValue } = useFormikContext()
  const [mainListField] = useField<EmsIdlePeriodLegacyFormField[]>(formFieldName)

  const updateWholeSet = (
    isActive: boolean,
    start: string | undefined,
    end: string | undefined,
    fieldValues: EmsIdlePeriodLegacyFormField[]
  ): void => {
    setFieldValue(
      formFieldName,
      fieldValues.map(
        item =>
          ({
            discharge: { ...item.discharge, isActive, start: start ?? item.discharge.start, end: end ?? item.discharge.end },
            charge: { ...item.charge, isActive, start: start ?? item.charge.start, end: end ?? item.charge.end },
            dayOfWeek: item.dayOfWeek,
          } as EmsIdlePeriodLegacyFormField)
      )
    )
  }

  const toggleForDayDialog = (processingType: IdlePeriodStatusProcessingType): void => {
    openSmartChargeToggleIdlePeriodDialog({
      processingType,
      onConfirm: (type, values?: PeriodFormInputType) => {
        const doActivate = type === 'activate'

        if (values && values.isActive) {
          updateWholeSet(doActivate, values.start, values.end, mainListField.value)
        } else {
          updateWholeSet(doActivate, undefined, undefined, mainListField.value)
        }
      },
    })
  }

  return { toggleForSinglePeriodDialog: toggleForDayDialog }
}

export default useIdlePeriod
